import { render, staticRenderFns } from "./TemplateBackupBanner.vue?vue&type=template&id=edc5efe6"
import script from "./TemplateBackupBanner.vue?vue&type=script&lang=js"
export * from "./TemplateBackupBanner.vue?vue&type=script&lang=js"
import style0 from "./TemplateBackupBanner.vue?vue&type=style&index=0&id=edc5efe6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports